import { css } from 'styled-system/css';

export const asideBetslipStyle = {
	text: css({
		base: {
			h: '60px'
		}
	}) 
}